<template>
    <div class="safety-page">
        <div class="page-container">
            <section>
                <h1 class="eyebrow-page fw-semibold omnes">
                    <span class="omnes">
                        JORNAY PM has a safety profile that is consistent with
                        other methylphenidate products<sup class="omnes"
                            >1</sup
                        ></span
                    >
                </h1>
            </section>

            <section class="adverse-reactions">
                <h2 class="open-sans fw-bold">
                    During the open-label dose-optimization phase of Study 1,
                    for patients 6-12 years of age, adverse reactions reported
                    in >5% of patients included:
                </h2>

                <div class="top-note">
                    <p>
                        Any insomnia (41%), decreased appetite (27%), affect
                        lability (22%), headache (19%), upper respiratory tract
                        infection (17%), upper abdominal pain (9%), nausea or
                        vomiting (9%), increased diastolic blood pressure (8%),
                        tachycardia (7%), and irritability (6%). Three patients
                        discontinued treatment due to affect of lability, panic
                        attacks, and agitation and aggression.<sup>2</sup>
                    </p>
                </div>

                <ul class="study-list">
                    <li class="pl-4">
                        <strong>No increase in adverse reactions</strong> when
                        the dose was increased in Pivotal Study 1 during dose
                        optimization<sup>3</sup>
                    </li>

                    <li class="pl-4">
                        <strong>No JORNAY PM patients withdrew</strong> because
                        of insomnia or decreased appetite in the pivotal
                        trials<sup>1,4</sup>
                    </li>
                </ul>

                <h3 class="fw-bold">
                    Adverse reactions occurring in ≥2% of JORNAY PM-treated
                    patients aged 6 to 12 years and greater than placebo in a
                    3-week ADHD study (Study 2)<sup>2</sup>
                </h3>

                <ul class="study-list study-list--2">
                    <li class="pl-4">
                        Study 2 was a 3-week, double-blind, randomized,
                        placebo-controlled study that evaluated the efficacy and
                        safety of JORNAY PM with ADHD-RS-IV as primary
                        endpoint<sup>2</sup>
                    </li>
                </ul>
            </section>

            <section class="table-section">
                <div class="safety-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Adverse Reaction<sup>2</sup></th>
                                <th>JORNAY PM (n=81)</th>
                                <th>Placebo (n=80)</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr class="bg-g">
                                <td>Any insomnia</td>
                                <td>33%</td>
                                <td>9%</td>
                            </tr>

                            <tr class="indent">
                                <td>Initial insomnia</td>
                                <td>14%</td>
                                <td>5%</td>
                            </tr>
                            <tr class="indent">
                                <td>Middle insomnia</td>
                                <td>11%</td>
                                <td>4%</td>
                            </tr>
                            <tr class="indent">
                                <td>Terminal insomnia</td>
                                <td>11%</td>
                                <td>1%</td>
                            </tr>
                            <tr class="indent">
                                <td><span>Insomnia, not specified</span></td>
                                <td>4%</td>
                                <td>1%</td>
                            </tr>
                            <tr class="bg-g">
                                <td>Affect lability/mood swings</td>
                                <td>6%</td>
                                <td>1%</td>
                            </tr>
                            <tr>
                                <td>Decreased appetite</td>
                                <td>19%</td>
                                <td>4%</td>
                            </tr>
                            <tr class="bg-g">
                                <td>Headache</td>
                                <td>10%</td>
                                <td>5%</td>
                            </tr>
                            <tr>
                                <td>Psychomotor hyperactivity</td>
                                <td>5%</td>
                                <td>1%</td>
                            </tr>
                            <tr class="bg-g">
                                <td>Blood pressure diastolic increased</td>
                                <td>7%</td>
                                <td>4%</td>
                            </tr>
                            <tr>
                                <td>Vomiting</td>
                                <td>9%</td>
                                <td>0%</td>
                            </tr>
                            <tr class="bg-g">
                                <td>Nausea</td>
                                <td>6%</td>
                                <td>0%</td>
                            </tr>
                            <tr>
                                <td>Nasopharyngitis</td>
                                <td>3%</td>
                                <td>1%</td>
                            </tr>
                            <tr class="bg-g">
                                <td>Pharyngitis streptococcal</td>
                                <td>3%</td>
                                <td>0%</td>
                            </tr>
                            <tr>
                                <td>Contusion</td>
                                <td>3%</td>
                                <td>0%</td>
                            </tr>
                            <tr class="bg-g">
                                <td>Back pain</td>
                                <td>3%</td>
                                <td>0%</td>
                            </tr>
                            <tr>
                                <td>Rash</td>
                                <td>2%</td>
                                <td>0%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="note">
                    <p>
                        ADHD-RS-IV=attention-deficit/hyperactivity disorder
                        rating scale, version IV.
                    </p>
                </div>
            </section>
        </div>

        <section class="affordable-main">
            <div class="page-container affordable">
                <h2 class="open-sans">
                    Broad commercial and Medicaid coverage.<sup>5,6</sup> JORNAY
                    PM offers a savings program for eligible, commercially
                    insured patients.
                </h2>

                <p class="fw-semibold">
                    Learn more about
                    <router-link to="/savings">patient savings</router-link>, or
                    if you need assistance finding a particular dosage strength,
                    call our Pharmacy Locator service at 1-877-938-4766,
                    Monday-Friday 8 <span class="ampm">AM</span> to 9
                    <span class="ampm">PM</span> ET.
                </p>
            </div>
        </section>

        <CTABanner
            :onlyBanner="true"
            :bannerData="{
                bannerText: 'SEE SAVINGS & RESOURCES',
                href: '/savings',
            }"
        />
    </div>
</template>

<script>
import FooterForm from '../components/global/FooterForm.vue';
import VideoCard from '../components/home/VideoCard.vue';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import headers from '../models/headers';
import BottomBanner from '../components/BottomBanner.vue';
import CTABanner from '../components/CTABanner.vue';

export default {
    components: {
        FooterForm,
        VideoCard,
        vueCustomScrollbar,
        CTABanner,
        BottomBanner,
    },
    metaInfo: headers.safetyPage(),
    data() {
        return {
            settings: {
                suppressScrollY: true,
                suppressScrollX: false,
                wheelPropagation: true,
            },
        };
    },
    methods: {},
};
</script>
